


























































































import { Vue, Component } from "@/shared/vuepack";
import { BrowserIdentifier, browserNameMap, UserPermission } from "@/shared/types";
import { BrowserRule } from "@/admin/types";
import GenericLoadingSpinner from "@/shared/components/ui/GenericLoadingSpinner.vue";
import BrowserRuleEdit from "@/admin/components/utility/BrowserRuleEdit.vue";
import { useBrowserRuleStore } from "@/admin/store/browserRule";
import { useRolePermissionsStore } from "@/shared/store/rolePermissions";
import moment from "moment";
import _ from "lodash";

@Component({
  components: {
    BrowserRuleEdit,
    GenericLoadingSpinner
  }
})
export default class BrowserRuleManage extends Vue {
  browserRuleStore = useBrowserRuleStore();
  rolePermissionsStore = useRolePermissionsStore();

  browserNameMap = browserNameMap;
  browserToDelete: BrowserIdentifier = null;
  showRemoveConfirmation = false;
  browserEditParams = {
    isNew: false,
    rule: null,
    show: { value: false }
  };

  get isLoading () {
    return this.browserRuleStore.isLoading;
  }

  get isLoaded () {
    return this.browserRuleStore.isLoaded;
  }

  get isFailed () {
    return this.browserRuleStore.isFailed;
  }

  get hasData () {
    return this.browserRuleStore.browserRules.length > 0;
  }

  get hasEditPermission () {
    return this.rolePermissionsStore.userHasAdminPermission(UserPermission.AdminPortalUtilityBrowserRulesEdit);
  }

  get tableItems () {
    return _.sortBy(this.browserRuleStore.browserRules, rule => browserNameMap[rule.browser]);
  }

  mounted () {
    this.refresh();
  }

  refresh () {
    this.browserRuleStore.loadBrowserRules();
  }

  onAddBrowser () {
    this.showBrowserEdit({ isNew: true });
  }

  onEditBrowser (rule: BrowserRule) {
    this.showBrowserEdit({ isNew: false, rule });
  }

  showBrowserEdit (params: { isNew: boolean, rule?: BrowserRule }) {
    if (params.rule) {
      this.browserEditParams.rule = params.rule;
    } else {
      this.browserEditParams.rule = null;
    }

    this.browserEditParams.isNew = params.isNew;
    this.browserEditParams.show.value = true;
  }

  onRemoveBrowser (rule: BrowserRule) {
    this.browserToDelete = rule.browser;
    this.showRemoveConfirmation = true;
  }

  deleteBrowser () {
    if (!this.browserToDelete) {
      return;
    }

    this.browserRuleStore.deleteBrowserRule(this.browserToDelete);
  }

  onRemoveConfirmationHidden () {
    this.browserToDelete = null;
  }

  formatDateString (fromString: any) {
    if (!fromString) {
      return "";
    }

    return moment.utc(fromString).local().format("L");
  }
}
